import { Component, OnInit, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { EloquaFormType } from '@app/enums/_index';
import { environment } from '@environments/environment';

// NOTE: Declare vars needed to access Jquery calls which Eloqua is dependent.
declare var $: any;
declare var addEloquaFormsScripts: any;
declare var loadEloquaForm: any;

@Component({
  selector: 'app-eloqua-form',
  templateUrl: './eloqua-form.component.html',
  styleUrls: ['./eloqua-form.component.scss'],
  standalone: false,
})
export class EloquaFormComponent implements OnInit {
  // Load Eloqua form based on formType
  @Input() formType: string;
  @Input() redirectUrl: string;
  @Output() sendClick = new EventEmitter<boolean>();

  constructor(private element: ElementRef) {}

  /**
   * Load Initial Eloqua scripts and Form
   */
  async ngOnInit(): Promise<void> {
    if (environment.beyond.featureFlags.eloquaFormIsDarkTheme) {
      document.body.classList.add('dark-theme');
    } else {
      document.body.classList.remove('dark-theme');
    }
    // Load Eloqua form scripts
    await addEloquaFormsScripts();
    // Load Eloqua form
    this.loadForm();
  }

  /**
   * Overwrite Country field from Eloqua to show State field only for certain countries.
   * NOTE: $ function call is JQuery function call
   */
  changeCountry(): void {
    const selectCountry = $('.elq-item-select[name$="country"]');
    const formFieldStateID = this.getFormFieldStateId();
    $(selectCountry).change(function (): void {
      if (this.value === 'United States' || this.value === 'Canada' || this.value === 'Australia') {
        $(formFieldStateID).css('display', 'block');
      } else {
        $(formFieldStateID).css('display', 'none');
      }
    });
  }

  /**
   * Close the Modal when the cancel button is clicked from Eloqua.
   */
  closeModal(): void {
    if (this.element) {
      this.sendClick.emit(true);
    }
  }

  /**
   * Load Eloqua and overwrite some of the form attributes
   * NOTE: $ function call is JQuery function call
   */
  loadForm(): void {
    const scope = this;
    loadEloquaForm(this.formType);

    const checkForm = setInterval(() => {
      if (
        scope.element &&
        scope.element.nativeElement &&
        scope.element.nativeElement.querySelector('.btn-cancel')
      ) {
        scope.element.nativeElement
          .querySelector('.btn-cancel')
          .addEventListener('click', scope.closeModal.bind(scope));
      }

      const formFieldStateID = this.getFormFieldStateId();
      if ($('form[name="MasterLeadIntakeForm"]').length && $(formFieldStateID).length) {
        $(formFieldStateID).css('display', 'none');
        scope.element.nativeElement
          .querySelector('select[name="country"]')
          .addEventListener('change', scope.changeCountry.bind(scope));
        clearInterval(checkForm);
      }
    }, 100);
  }

  /**
   * This will return will correct field state ID based on formType
   * @returns the correct field state ID
   */
  getFormFieldStateId(): string {
    switch (this.formType) {
      case EloquaFormType.BEYONDCX:
        return 'div.field-state';
      case EloquaFormType.REQUEST_A_QUOTE:
        return 'div.request-quote-column.state';
      default:
        return '';
    }
  }
}
